import { FC, useState } from 'react';
import { ErrorMessages, LoginPlaceholder } from '../../utils/helper.type';
import { useTranslation } from 'react-i18next';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { NetPasswordProps } from './newPassword.type';
import {
  renderDesktopView,
  renderTabletView,
} from '../setPassword/setPasswordHelper';
import { Navigate, useNavigate } from 'react-router-dom';
import { route } from '../../service/router';
import { getPasswordParams } from '../../utils/helper';
import { useNewPasswordData } from '../../hooks/useAuthData';

const NewPassword: FC<NetPasswordProps> = () => {
  const { isDesktop } = useResponsiveLayout();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const loginTranslation: LoginPlaceholder =
    i18n.getResourceBundle(i18n.language, 'translation')?.login.placeholder ||
    {};
  const { newPassword, isNewPasswordLoading, error, setError } =
    useNewPasswordData();

  const [params] = useState(() => getPasswordParams());
  const { code, email } = params;

  if (!code || !email)
    return (
      <Navigate
        to={route.invalidLinkPage}
        replace
        state={{ messageDesc: 'newPassword' }}
        data-testid="navigate-invalid"
      />
    );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isNewPasswordLoading) {
      console.log('[NewPassword] Already in progress... skipping this request');
      return;
    }

    setError(null);
    if (password !== confirmPassword) {
      setError(ErrorMessages.PASSWORD_MISMATCH);
      return;
    }
    try {
      if (!email || code === null) {
        return;
      }
      await newPassword(email, password, code);
    } catch (err) {
      setError(ErrorMessages.PASSWORD_FAILED);
    }
  };

  const handleBackToLogin = (): void => {
    navigate(route.login);
  };

  return (
    <div
      className="relative min-h-screen w-full"
      data-testid="new-password-container"
    >
      {isDesktop
        ? renderDesktopView(
            handleSubmit,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            loginTranslation,
            showPassword,
            setShowPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            error,
            'newPassword.createNew',
            'newPassword.createPassword',
            isNewPasswordLoading,
            !password || !confirmPassword,
          )
        : renderTabletView(
            handleSubmit,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            loginTranslation,
            showPassword,
            setShowPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            error,
            handleBackToLogin,
            'newPassword.createNewPassword',
            'newPassword.createPassword',
            isNewPasswordLoading,
            !password || !confirmPassword,
          )}
    </div>
  );
};

export default NewPassword;
